import { useEffect, useRef } from "react";
import { Input } from "antd";
import { getStore } from "../../utils/global";

const globalStyle = {
  fontSize: "11px",
  fontFamily: "'Roboto'",
  fontWeight: "normal",
  color: "#000000",
};

const Drag = ({
  left,
  bottom,
  unique_key,
  style,
  color,
  drag_txt,
  disabled,
  index,
  locked,
  updateHandler,
  url,
  value,
  lockInputs,
  dragstart,
  body,
  username,
}) => {
  const inputRef = useRef(null);
  const ref = useRef(null);
  const customFields = getStore("customFields");

  const onMouseDown = (e) => {
    let rect = e.target.getBoundingClientRect();
    let shiftX = e.offsetX;
    let shiftY = e.offsetY;

    if (rect.width - shiftX > 8 && rect.height - shiftY > 8) {
      ref.current.setAttribute("shiftx", shiftX);
      ref.current.setAttribute("shifty", shiftY);
      if (disabled) return;
      if (locked) return;
      dragstart(ref.current);
    }
  };

  useEffect(() => {
    ref.current = document.querySelector("#" + unique_key + index);
    ref.current.addEventListener("mousedown", onMouseDown);
    const handlePasteAnywhere = (event) => {
      if (event.target.id === `input_${unique_key}_${index}`) {
        updateHandler(event);
      }
    };

    window.addEventListener("paste", handlePasteAnywhere);

    return () => {
      window.removeEventListener("paste", handlePasteAnywhere);
      if (ref.current) {
        ref.current.removeEventListener("mousedown", onMouseDown);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unique_key, index, disabled, locked, dragstart, updateHandler]);

  const onInputChange = (val) => {
    inputRef.current.innerHTML = val;
  };

  if (unique_key === "shortText") {
    const maxChar = customFields.find((field) => field.unique_key === "shortText")?.maxChar || 31;
    return (
      <>
        <div
          id={unique_key + index}
          className={`drag ${locked ? "" : disabled ? "drag_disabled" : ""}`}
          style={{
            display: "flex",
            bottom: bottom,
            left: left,
            width: style.width,
            height: "auto",
            backgroundColor: color,
            border: `1px solid ${color}`,
          }}>
          {disabled && <div className="drag_box_overlay" style={{ zIndex: 4 }} />}
          <div
            ref={inputRef}
            style={{
              position: "absolute",
              height: "100%",
              opacity: 0,
              left: 0,
              top: 0,
              bottom: 0,
              right: 0,
              ...globalStyle,
            }}
          />
          <Input
            className="placeholder_style"
            value={value}
            readOnly={lockInputs}
            id={`input_${unique_key}_${index}`}
            rows={1}
            maxLength={maxChar}
            onChange={(e) => {
              updateHandler(e);
              onInputChange(e.target.value);
            }}
            style={{
              ...globalStyle,
              padding: 2,
              resize: "both !important",
              width: "100%",
              height: "auto",
              blockSize: "fit-content",
              backgroundColor: "transparent",
              overflow: "auto !important",
              zIndex: 5,
            }}
            placeholder="Enter custom text here."
            autoSize={{ minRows: 1, minCols: 12 }}
            defaultValue={value}
            width="100%"
          />
        </div>
      </>
    );
  }

  // For Web Link
  if (unique_key === "link") {
    const maxChar = customFields.find((field) => field.unique_key === "link")?.maxChar || 31;
    return (
      <>
        <div
          id={unique_key + index}
          className={`drag ${locked ? "" : disabled ? "drag_disabled" : ""}`}
          style={{
            display: "flex",
            bottom: bottom,
            left: left,
            width: "auto",
            height: "auto",
            backgroundColor: color,
            border: `1px solid ${color}`,
          }}>
          {disabled && <div className="drag_box_overlay" />}
          <div
            ref={inputRef}
            style={{
              position: "absolute",
              height: "100%",
              opacity: 0,
              left: 0,
              top: 0,
              bottom: 0,
              right: 0,
              ...globalStyle,
            }}
          />
          <Input
            className="placeholder_style"
            value={value}
            readOnly={lockInputs}
            id={`input_${unique_key}_${index}`}
            maxLength={maxChar}
            onChange={(e) => {
              updateHandler(e);
              onInputChange(e.target.value);
            }}
            style={{
              ...globalStyle,
              padding: 2,
              resize: "both",
              width: "fit-content",
              height: "auto",
              blockSize: "fit-content",
              backgroundColor: "transparent",
              overflow: "auto !important",
              zIndex: 5,
            }}
            placeholder="Enter link here"
            autoSize={{ minRows: 1, minCols: 12 }}
            defaultValue={value}
          />
        </div>
      </>
    );
  }

  if (unique_key === "mediumText") {
    const maxChar = customFields.find((field) => field.unique_key === "mediumText")?.maxChar || 48;
    return (
      <>
        <div
          id={unique_key + index}
          className={`drag ${locked ? "" : disabled ? "drag_disabled" : ""}`}
          style={{
            display: "flex",
            bottom: bottom,
            left: left,
            width: style.width,
            height: "auto",
            backgroundColor: color,
            border: `1px solid ${color}`,
          }}>
          {disabled && <div className="drag_box_overlay" />}
          <div
            ref={inputRef}
            style={{
              position: "absolute",
              height: "100%",
              opacity: 0,
              left: 0,
              top: 0,
              bottom: 0,
              right: 0,
              ...globalStyle,
            }}
          />
          <Input
            className="placeholder_style"
            value={value}
            readOnly={lockInputs}
            id={`input_${unique_key}_${index}`}
            rows={1}
            maxLength={maxChar}
            onChange={(e) => {
              updateHandler(e);
              onInputChange(e.target.value);
            }}
            style={{
              ...globalStyle,
              padding: 2,
              resize: "both !important",
              width: "100%",
              height: "auto",
              blockSize: "fit-content",
              backgroundColor: "transparent",
              overflow: "auto !important",
              zIndex: 5,
            }}
            placeholder="Enter custom text here."
            autoSize={{ minRows: 1, minCols: 12 }}
            defaultValue={value}
          />
        </div>
      </>
    );
  }

  if (unique_key === "largeText") {
    const maxChar = customFields.find((field) => field.unique_key === "largeText")?.maxChar || 98;
    return (
      <>
        <div
          id={unique_key + index}
          className={`drag ${locked ? "" : disabled ? "drag_disabled" : ""}`}
          style={{
            display: "flex",
            bottom: bottom,
            left: left,
            width: style.width,
            height: "auto",
            backgroundColor: color,
            border: `1px solid ${color}`,
          }}>
          {disabled && <div className="drag_box_overlay" />}
          <div
            ref={inputRef}
            style={{
              position: "absolute",
              height: "100%",
              opacity: 0,
              left: 0,
              top: 0,
              bottom: 0,
              right: 0,
              ...globalStyle,
            }}
          />
          <Input
            className="placeholder_style"
            value={value}
            readOnly={lockInputs}
            id={`input_${unique_key}_${index}`}
            maxLength={maxChar}
            onChange={(e) => {
              updateHandler(e);
              onInputChange(e.target.value);
            }}
            style={{
              ...globalStyle,
              padding: 2,
              resize: "both !important",
              width: "100%",
              height: "auto",
              blockSize: "fit-content",
              backgroundColor: "transparent",
              overflow: "auto !important",
              zIndex: 5,
            }}
            placeholder="Enter custom text here."
            autoSize={{ minRows: 1, minCols: 12 }}
            defaultValue={value}
          />
        </div>
      </>
    );
  }

  // For other fields than custom text
  return (
    <div
      id={unique_key + index}
      ref={ref}
      className={`drag ${locked ? "" : disabled ? "drag_disabled" : ""}`}
      style={{
        bottom: bottom,
        left: left,
        width: style.width,
        height: style.height,
        backgroundColor: url ? "transparent" : color,
        border: `1px solid ${color}`,
        backgroundImage: `url(${url})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPositionX: "right",
        ...globalStyle,
      }}>
      <div className="drag_box_overlay" />
      {body ? body : url ? <span className="yourSignature">{drag_txt}</span> : <span>{drag_txt}</span>}
      {username && <span className="stamp_username">{username}</span>}
    </div>
  );
};

export default Drag;
